import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import Cookies from 'universal-cookie'

import { PreviewContext } from './preview-context'
import { logoutPreview } from 'services/preview'
import { withEndUser } from 'components/providers/end-user'
import PreviewBaneer  from 'components/preview-baneer'

const cookies = new Cookies()
const PREVIEW_COOKIE_NAME = 'Portal-Preview'

class PreviewProvider extends Component {

  constructor(props) {
    super(props)

    this.state = this.getInitialState()
  }

  isEnabled = () => {
    const { user_id, hotspot_ip } = this.formatCookie(PREVIEW_COOKIE_NAME)
    return user_id || hotspot_ip
  }

  isExpired = () => {
    return !!this.state.isExpired
  }

  disable = (isExpired = false) => {
    logoutPreview()
      .then(() => {
        this.setState({ data: null, isExpired })
        window.location.href = window.location.href.split('?')[0]
      })
      .catch(err => console.log(err))
  }

  disableAndExpire = () => {
    this.disable(true)
  }

  getInitialState = () => {
    if (!this.isEnabled()) {
      return {
        data: null,
        isExpired: false
      }
    }
    const { user_id, hotspot_ip } = this.formatCookie(PREVIEW_COOKIE_NAME)
    return { data : { userId: user_id, hotspotIp: hotspot_ip }, isExpired: false }
  }

  formatCookie(name) {
    const value = cookies.get(name)
    return ( value !== "undefined" ? value : {} ) || {}
  }

  get baneerMessage() {
    const {data: {userId, hotspotIp}} = this.state
    let message = []
    if (userId) message.push(`utilisateur ID ${userId}`)
    if (hotspotIp) message.push(`IP ${hotspotIp}`)
    return message.join(' ')
  }
  componentDidMount() {
    window.addEventListener('previewTokenExpired', this.disableAndExpire)
  }

  componentWillUnmount() {
    window.removeEventListener('previewTokenExpired', this.disableAndExpire)
  }

  render() {
    const value = {
      data:       this.state.data,
      isEnabled:  this.isEnabled,
      isExpired:  this.isExpired,
      disable:    this.disable,
      baneer: {
        message: this.isEnabled() ? `Preview ${this.baneerMessage}` : ''
      }
    }

    return (
      <PreviewContext.Provider value={value}>
        <PreviewBaneer preview={value} />
        {typeof this.props.children === 'function'
          ? this.props.children(this.state.preview)
          : this.props.children
        }
      </PreviewContext.Provider>
    )
  }
}

PreviewProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ])
}

export default withRouter(withEndUser(PreviewProvider))
